export const NotifyAudioList = {
    notification: 'notification.mp3'
};